<mat-label style="font-size: 14px; display: block;">{{name}}</mat-label>
<mat-label style="font-size: 12px;display: inline;">{{('GenderEnums.' + gender) | translate }}</mat-label>
<span class="ageBulletIndicator"></span>
<mat-label style="font-size: 12px;display: inline;">{{age}} {{yrs}}</mat-label>